@if (!twoStepUploadEnabled && !multidocUploadv2) {
    <div>
        <div class="form-group mb-4" id="ptuploadfile">
            @if (!enableCardInfo) {
                <label class="form-group-label" [ngClass]="{ 'spacing-br': fromPersonalDetails() }" [vnDynamicHtml]="label"></label>
            }
            <div class="form-control-container">
                @if (enableDragAndDrop) {
                    <div
                        class="file-upload-input mb-1"
                        [class.document-upload-valid]="hasAddedDocument"
                        [class.file-upload-invalid]="isError"
                        [ngClass]="{
                            'h-25': enableCardInfo && !hasAddedDocument,
                            'file-multi-doc-input': isMultiDocUpload,
                            'upload-file-color': acqEnhancements && imageData.Name,
                            'text-alignleft-br': fromPersonalDetails(),
                        }"
                        (click)="chooseFile()"
                        (dragover)="allowDrop($event)"
                        (drop)="drop($event)">
                        @if (!isMultiDocUpload) {
                            <div class="doc-text-overflow" [attr.title]="imageData.Name" [ngClass]="{ 'text-left': fromPersonalDetails() }">
                                @if (enableCardInfo && (!imageData || !imageData.Name)) {
                                    <span [vnDynamicHtml]="content.messages.withdrwDocUpload"></span>
                                } @else {
                                    @if (imageData && imageData.Name) {
                                        <span>{{ imageData.Name }}</span>
                                    }
                                    @if (!enableUploadpaymentCard && !isTouch && (!imageData || !imageData.Name)) {
                                        <span [ngClass]="{ 'add-photo-color': acqEnhancements }">{{
                                            acqEnhancements ? content.messages['AddPhoto'] : content.messages['DragDropSectionText']
                                        }}</span>
                                    }
                                    @if (enableUploadpaymentCard && !isTouch && (!imageData || !imageData.Name)) {
                                        <span>{{ content.messages['pxpDragDropSectionText'] }}</span>
                                    }
                                    @if (isTouch && (!imageData || !imageData.Name) && !enableUploadpaymentCard) {
                                        <span [ngClass]="{ 'add-photo-color': acqEnhancements }">{{
                                            acqEnhancements ? content.messages['AddPhoto'] : fileUploadText
                                        }}</span>
                                    }
                                }
                            </div>
                        }
                        @if (isMultiDocUpload) {
                            <div>
                                <div class="text-center" id="multi-doc-upload-icon">
                                    <img [src]="content.messages['UploadIcon']" />
                                </div>
                                @if (filesList.length == 0) {
                                    <div>{{ content.messages['DragDropSectionTextMultiDoc'] }}</div>
                                }
                                @if (filesList.length > 0) {
                                    <div>{{ content.messages['DragDropSectionTextDocAddedMultiDoc'] }}</div>
                                }
                                <div>{{ content.messages['AllowedDocsMultiDoc'] }}</div>
                            </div>
                        }
                    </div>
                }
                <div (click)="allowFileUpload($event)">
                    <input
                        #fileInput
                        hidden
                        id="uploadFile"
                        type="file"
                        [accept]="ACCEPT_TYPES"
                        [disabled]="!allowUpload"
                        [isMultiDocument]="isMultiDocUpload"
                        (imageError)="imageError($event)"
                        (imageLoaded)="imageLoaded($event)"
                        (ptImagePicked)="imagePicked($event)" />
                </div>
                @if (isError) {
                    @if (fromPersonalDetails()) {
                        <div class="message-panel custom-error m2-validation-messages icon-br">
                            <div class="theme-error-i">
                                <div class="cms-container">{{ errorMessage }}</div>
                            </div>
                        </div>
                    } @else {
                        <div class="custom-error m2-validation-messages">
                            <span class="m2-validation-message" [innerHtml]="errorMessage"></span>
                        </div>
                    }
                }
                @if (hasAddedDocument && !isError && !isMultiDocUpload) {
                    <div class="custom-valid m2-validation-messages" [ngClass]="{ 'upload-green-br': fromPersonalDetails() }"></div>
                }
                @if (!isTouch && allowUpload && showChooseFileLink && !enableUploadpaymentCard && !enableCardInfo) {
                    <a class="pc-txt txt-s dh" [ngClass]="{ 'text-info': fromPersonalDetails() }" (click)="chooseFile()">
                        <u [vnDynamicHtml]="enableDragAndDrop ? content.messages['ChooseFileLink'] : content.messages['VCClientChooseFileLink']"></u>
                    </a>
                }
                @if (!isMultiDocUpload && !fromPersonalDetails()) {
                    <span class="file-upload-clear theme-close-i text-danger" [hidden]="!hasAddedDocument" (click)="clearFile()"></span>
                }
                @if (filesList && isMultiDocUpload) {
                    <div>
                        @for (file of filesList; track $index) {
                            <div class="multi-doc-upload">
                                <div class="my-2">
                                    <div id="file-image" [ngClass]="{ 'invert-colors': darkModeEnabled }">
                                        <img class="multi-doc-image" [src]="content.messages[file.ContentType]" />
                                    </div>
                                    <div class="multi-doc-upload-details">
                                        <div class="file-info">
                                            <span class="levels-font" [title]="file.Name">{{ file.Name }}</span>
                                            <span class="text-muted-secondary bonus-card-heading-1-small"></span>
                                        </div>
                                        <div class="file-size-info">
                                            <span class="levels-font">{{ file.fileSizeInText }}</span>
                                            <span class="text-muted-secondary bonus-card-heading-1-small"></span>
                                        </div>
                                        <div class="background-bar mt-3">
                                            <div
                                                class="progress w-100"
                                                [ngClass]="{
                                                    'bg-success': file.UploadedSuccessfully,
                                                    'bg-danger': !file.UploadedSuccessfully || file.TotalFileSizeExceeded,
                                                }"></div>
                                        </div>
                                        <div class="file-uploaded-success">
                                            @if (file.UploadedSuccessfully && !file.TotalFileSizeExceeded) {
                                                <span class="file-upload-status-font file-upload-success">{{
                                                    content.messages['SuccessfullyUploaded']
                                                }}</span>
                                            }
                                            @if (!file.UploadedSuccessfully) {
                                                <span class="file-upload-status-font file-upload-failed">{{
                                                    content.messages['NotSuccessfullyUploaded']
                                                }}</span>
                                            }
                                            @if (file.TotalFileSizeExceeded && file.UploadedSuccessfully) {
                                                <span
                                                    class="file-upload-status-font file-upload-failed"
                                                    [vnDynamicHtml]="content.messages['CumulativeFileSizeExceeded']"></span>
                                            }
                                            <span class="text-muted-secondary bonus-card-heading-1-small"></span>
                                        </div>
                                        <div class="file-remove">
                                            <span class="points-font underline cursorPointer" (click)="clearThisFile(file)">{{
                                                content.messages['RemoveFile']
                                            }}</span>
                                            <span class="text-muted-secondary bonus-card-heading-1-small"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
            @if (acqEnhancements) {
                <span class="mt-2 d-flex justify-content-center txt-xs-v2 txt-color-60">{{ content.messages['AllowedOtherFileTypes'] }}</span>
            }
        </div>
    </div>
}
@if (twoStepUploadEnabled && !multidocUploadv2) {
    <div>
        <div class="form-group mb-4" id="ptuploadfile">
            @if (!step2) {
                <div class="form-control-container">
                    <span class="d-inline-block mt-2">{{ content.messages['UploadstepOneDocument'] }}</span>
                    <span class="d-inline-block mt-2">{{ content.messages['DragDropSectionTitle'] }}</span>
                </div>
            }
            @if (step2) {
                <div>
                    <span class="d-inline-block mt-2">{{ content.messages['UploadstepTwoDocument'] }}</span>
                    <span class="d-inline-block mt-2">{{ content.messages['DragDropSectionTitlePesel'] }}</span>
                </div>
            }
            <div class="form-control-container mt-2">
                @if (enableDragAndDrop) {
                    <div
                        class="file-upload-input mb-1 file-multi-doc-input"
                        [class.document-upload-valid]="hasAddedDocument"
                        [ngClass]="{ 'text-alignleft-br': fromPersonalDetails() }"
                        (click)="chooseFile()"
                        (dragover)="allowDrop($event)"
                        (drop)="drop($event)">
                        <div>
                            <div class="text-center" id="multi-doc-upload-icon">
                                <img [src]="content.messages['UploadIcon']" />
                            </div>
                            @if (filesList.length == 0) {
                                <div>{{ content.messages['DragDropSectionTextMultiDoc'] }}</div>
                            }
                            <div>{{ content.messages['AllowedDocsMultiDoc'] }}</div>
                        </div>
                    </div>
                }
                <div (click)="allowFileUpload($event)">
                    <input
                        #fileInput
                        hidden
                        id="uploadFile"
                        type="file"
                        [accept]="ACCEPT_TYPES"
                        [disabled]="!allowUpload"
                        [isMultiDocument]="false"
                        (imageError)="imageError($event)"
                        (imageLoaded)="imageLoaded($event)"
                        (ptImagePicked)="imagePicked($event)" />
                </div>
                <div>
                    <div class="multi-doc-upload">
                        <div class="my-2">
                            @if (isShowProgressBar) {
                                <div id="file-image" [ngClass]="{ 'invert-colors': darkModeEnabled }">
                                    <img class="multi-doc-image" [src]="content.messages[imageData.ContentType]" />
                                </div>
                            }
                            <div class="multi-doc-upload-details">
                                <div class="file-info">
                                    <span class="levels-font" [title]="imageData.Name">{{ imageData.Name }}</span>
                                    <span class="text-muted-secondary bonus-card-heading-1-small"></span>
                                </div>
                                <div>
                                    @if (isShowProgressBar) {
                                        <div class="mt-2">
                                            <span class="progress-bar-wrapper">
                                                <div
                                                    Class="progress"
                                                    id="iban"
                                                    [ngClass]="{ 'progress-color-red': isError && progressWidth >= 100 }"
                                                    [style.width.%]="progressWidth"></div>
                                                @if (!showFailedProgressbar && progressWidth != 100) {
                                                    <div class="mb-2 mt-2 font-12">
                                                        {{ content.messages['Uploading'] }}
                                                        <span class="progress-value" id="progressValueV2"> 0%</span>
                                                    </div>
                                                }
                                                <div class="file-remove">
                                                    @if (progressWidth != 100) {
                                                        <span class="points-font underline cursorPointer" (click)="clearFile()">{{
                                                            content.messages['CancelFile']
                                                        }}</span>
                                                    }
                                                    <span class="text-muted-secondary bonus-card-heading-1-small"></span>
                                                </div>
                                            </span>
                                        </div>
                                    }
                                    @if (isShowProgressBar && !isError) {
                                        <span>
                                            @if (progressWidth >= 100) {
                                                <div class="file-uploaded-success">
                                                    <span class="file-upload-status-font file-upload-success">{{
                                                        content.messages['SuccessfullyUploaded']
                                                    }}</span>
                                                </div>
                                            }
                                            @if (progressWidth >= 100 && !isError) {
                                                <div class="file-remove">
                                                    <span class="points-font underline cursorPointer" (click)="clearFile()">{{
                                                        content.messages['RemoveFile']
                                                    }}</span>
                                                    <span class="text-muted-secondary bonus-card-heading-1-small"></span>
                                                </div>
                                            }
                                        </span>
                                    }
                                    @if (progressWidth >= 100 && isError && isShowProgressBar) {
                                        <span>
                                            <div class="file-uploaded-success">
                                                <span class="file-upload-status-font file-upload-failed">{{
                                                    content.messages['DocUploadErrorMessage']
                                                }}</span>
                                            </div>
                                            <div class="file-remove">
                                                <span class="points-font underline cursorPointer" (click)="clearFile()">{{
                                                    content.messages['Retry']
                                                }}</span>
                                                <span class="text-muted-secondary bonus-card-heading-1-small"></span>
                                            </div>
                                        </span>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
@if (multidocUploadv2) {
    <div>
        <div class="form-group mb-4" id="ptuploadfile">
            @if (showUploadInfo) {
                <div>
                    <div class="form-control-container">
                        <div class="d-inline-block mt-2">{{ content.messages['description'] }}</div>
                    </div>
                    <div class="pt-4">
                        <span class="d-flex ui-icon theme-info-i">
                            <span class="txt-s text-nowrap ml-2"
                                ><strong>{{ content.messages['UploadTip'] }}</strong></span
                            >
                        </span>
                    </div>
                    <div class="form-control-container" [innerHtml]="content.messages.uploadTipList | trustAsHtml"></div>
                </div>
            }
            <div class="form-control-container mt-2">
                @if (enableDragAndDrop) {
                    <div
                        class="file-upload-input mb-1 file-multi-doc-input"
                        [class.disabled]="!allowUpload"
                        [class.document-upload-valid]="hasAddedDocument"
                        [ngClass]="{ 'text-alignleft-br': fromPersonalDetails() }"
                        (click)="chooseFile()"
                        (dragover)="allowDrop($event)"
                        (drop)="drop($event)">
                        <div>
                            <div class="text-center" id="multi-doc-upload-icon">
                                <img [src]="content.messages['UploadIcon']" />
                            </div>
                            <div>{{ content.messages['DragDropSectionTextMultiDoc'] }}</div>
                            <div>{{ content.messages['AllowedDocsMultiDoc'] }}</div>
                        </div>
                    </div>
                }
                <div (click)="allowFileUpload($event)">
                    <input
                        #fileInput
                        hidden
                        id="uploadFile"
                        type="file"
                        [accept]="ACCEPT_TYPES"
                        [disabled]="!allowUpload"
                        [isMultiDocument]="false"
                        [isMultiDocumentV2]="multidocUploadv2"
                        (imageError)="imageError($event)"
                        (imageLoaded)="imageLoaded($event)"
                        (ptImagePicked)="imagePicked($event)" />
                </div>
                @if (isDuplicateFile) {
                    <div class="custom-error m2-validation-messages">
                        <span class="m2-validation-message" [innerHtml]="errorMessage"></span>
                    </div>
                }
                <div id="filesContainer" [ngClass]="{ scrollbar: isMobile && filesList.length > 2 }">
                    @for (media of filesList; track i; let i = $index) {
                        <div class="pt-1 pb-1">
                            <div class="multi-doc-upload">
                                <div class="my-2">
                                    @if (media.isShowProgressBar) {
                                        <div id="file-image" [ngClass]="{ 'invert-colors': darkModeEnabled }">
                                            <img
                                                class="multi-doc-image"
                                                [src]="
                                                    content.messages[media.ContentType]
                                                        ? content.messages[media.ContentType]
                                                        : content.messages['UnSupportedStaticImage']
                                                " />
                                        </div>
                                    }
                                    <div class="multi-doc-upload-details">
                                        <div class="file-info">
                                            <span class="levels-font" [title]="media.Name">{{ media.Name }}</span>
                                            <span class="text-muted-secondary bonus-card-heading-1-small"></span>
                                        </div>
                                        <div class="file-size-info">
                                            <span class="levels-font">{{ media.fileSizeInText }}</span>
                                            <span class="text-muted-secondary bonus-card-heading-1-small"></span>
                                        </div>
                                        <div class="pt-1">
                                            @if (media.isShowProgressBar) {
                                                <div class="mt-2">
                                                    <span class="progress-bar-wrapper">
                                                        <div
                                                            Class="progress"
                                                            id="iban"
                                                            [ngClass]="{ 'progress-color-red': media.isError && media.progressWidth >= 100 }"
                                                            [style.width.%]="media.progressWidth"></div>
                                                        @if (!media.showFailedProgressbar && media.progressWidth != 100) {
                                                            <div class="mb-2 mt-2 font-12">
                                                                {{ content.messages['Uploading'] }}
                                                                <span class="progress-value" [id]="media.fileName"> 0%</span>
                                                                <span
                                                                    class="file-remove points-font underline cursorPointer"
                                                                    (click)="clearFileV2(media, 'cancel')"
                                                                    >{{ content.messages['CancelFile'] }}</span
                                                                >
                                                                <span class="text-muted-secondary bonus-card-heading-1-small"></span>
                                                            </div>
                                                        }
                                                    </span>
                                                </div>
                                            }
                                            @if (media.isShowProgressBar && !media.isError) {
                                                <span class="pt-1">
                                                    @if (media.progressWidth >= 100) {
                                                        <div class="file-uploaded-success">
                                                            <span class="theme-success-i ui-icon-size-sm"></span>
                                                            <span class="ml-1 file-upload-status-font file-upload-success">{{
                                                                content.messages['SuccessfullyUploaded']
                                                            }}</span>
                                                        </div>
                                                    }
                                                    @if (media.progressWidth >= 100 && !media.isError) {
                                                        <div class="file-remove">
                                                            <span
                                                                class="points-font underline cursorPointer"
                                                                (click)="clearFileV2(media, 'remove')"
                                                                >{{ content.messages['RemoveFile'] }}</span
                                                            >
                                                            <span class="text-muted-secondary bonus-card-heading-1-small"></span>
                                                        </div>
                                                    }
                                                </span>
                                            }
                                            @if (media.progressWidth >= 100 && media.isError && media.isShowProgressBar) {
                                                <span class="pt-1">
                                                    <div class="file-uploaded-success">
                                                        <span class="theme-error-i ui-icon-size-sm"></span>
                                                        <span class="ml-1 file-upload-status-font file-upload-failed">{{ media.errorMessage }}</span>
                                                    </div>
                                                    <div class="file-remove">
                                                        <span class="points-font underline cursorPointer" (click)="clearFileV2(media, 'remove')">{{
                                                            content.messages['Retry']
                                                        }}</span>
                                                        <span class="text-muted-secondary bonus-card-heading-1-small"></span>
                                                    </div>
                                                </span>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    @if (TotalFileSizeExceeded) {
                        <div class="content-message-container">
                            <div class="content-message warning theme-warning">
                                <div class="page-matrix">
                                    <div class="pc-text pc-component">
                                        <span class="pc-richtext" [innerHtml]="content.messages.CumulativeFileSizeExceeded"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
}
